import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import useModalEffect from '../../../hooks/useModalEffect';

const ViewFormatNumber = ({ isOpen, onClose, data }) => {
  useModalEffect(isOpen);
  ;

  // Cleanup effect when component unmounts
  useEffect(() => {
    return () => {
      // Clean up any remaining modal states when component unmounts
      const cleanupModal = () => {
        // Remove modal scroll lock
        document.body.classList.remove('modal-open');
        document.body.style.overflow = '';
        document.body.style.paddingRight = '';
        document.body.classList.remove('modal-backdrop');
      };
      
      cleanupModal();
    };
  }, []);


  // Cleanup effect: reset modal body state when component unmounts.
  useEffect(() => {
    return () => {
      // React owns the backdrop DOM (createPortal); only reset body state here.
      // Remove modal-open class from body
      document.body.classList.remove('modal-open');
    };
  }, []);

  if (!data) return null;

  return (
    <>
      <style>{`
        #modal-view-format-number .inv-footer {
          border-top: 1px solid #e9ecef !important;
          background: #fff;
          padding: 1rem 1.5rem;
          display: flex; align-items: center; justify-content: flex-end; gap: 0.6rem;
          flex-shrink: 0;
        }
      `}</style>
      {isOpen && ReactDOM.createPortal(<div className="modal-backdrop fade show" style={{ zIndex: 1040 }} />, document.body)}
      <div
        className={`modal modal-blur fade${isOpen ? ' show' : ''}`} style={{ display: isOpen ? 'block' : 'none' }}
        id="modal-view-format-number"
        tabIndex="-1"
        role="dialog"
      >
        <div className="modal-dialog modal-md modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">View Format Number Details</h5>
              <button 
                type="button" 
                className="btn-close" 
                onClick={onClose}
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="row mb-3">
                <div className="col-4 fw-bold">Name</div>
                <div className="col-8">{data.name}</div>
              </div>
              <div className="row mb-3">
                <div className="col-4 fw-bold">Department Code</div>
                <div className="col-8">{data.departmentCode}</div>
              </div>
              <div className="row mb-3">
                <div className="col-4 fw-bold">Module Name</div>
                <div className="col-8">{data.moduleName}</div>
              </div>
              <div className="row mb-3">
                <div className="col-4 fw-bold">Suffix Code</div>
                <div className="col-8">{data.suffixCode}</div>
              </div>
              <div className="row mb-3">
                <div className="col-4 fw-bold">Include Years</div>
                <div className="col-8">{data.includeYears ? 'Yes' : 'No'}</div>
              </div>
              <div className="row mb-3">
                <div className="col-4 fw-bold">Include Months</div>
                <div className="col-8">{data.includeMonths ? 'Yes' : 'No'}</div>
              </div>
              <div className="row mb-3">
                <div className="col-4 fw-bold">Digit Length</div>
                <div className="col-8">{data.digitLength}</div>
              </div>
              <div className="row mb-3">
                <div className="col-4 fw-bold">Starting Number</div>
                <div className="col-8">{data.startingNumber}</div>
              </div>
              <div className="row mb-3">
                <div className="col-4 fw-bold">Current Number</div>
                <div className="col-8">{data.currentNumber || data.startingNumber}</div>
              </div>
              <div className="row mb-3">
                <div className="col-4 fw-bold">Reset Period</div>
                <div className="col-8">{data.resetPeriod}</div>
              </div>
              <div className="row mb-3">
                <div className="col-4 fw-bold">Example Output</div>
                <div className="col-8">
                  <code style={{ 
                    background: '#f8f9fa', 
                    padding: '8px 12px', 
                    borderRadius: '4px',
                    border: '1px solid #dee2e6'
                  }}>
                    {data.exampleOutput || 'No example available'}
                  </code>
                </div>
              </div>
              {data.createdAt && (
                <div className="row mb-3">
                  <div className="col-4 fw-bold">Created At</div>
                  <div className="col-8">{new Date(data.createdAt).toLocaleString()}</div>
                </div>
              )}
              {data.updatedAt && (
                <div className="row mb-3">
                  <div className="col-4 fw-bold">Updated At</div>
                  <div className="col-8">{new Date(data.updatedAt).toLocaleString()}</div>
                </div>
              )}
            </div>
            <div className="inv-footer">
              <button type="button" className="btn btn-outline-secondary" onClick={onClose}>
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

ViewFormatNumber.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  data: PropTypes.object
};

export default ViewFormatNumber; 